import React from 'react';

import { HeroSuperText, SanityDescription, SanityHeroHeading } from './styled';

export interface IMainHeroTextProps {
  html: string | null;
  defaultTextColor: string;
  heroTextColor: string | null;
  heroSuperText: string | null;
  heroSubText: string | null;
}

export const MainHeroText: React.FC<IMainHeroTextProps> = ({
  heroSuperText,
  defaultTextColor,
  heroTextColor,
  html,
  heroSubText,
}) => {
  return (
    <>
      {heroSuperText && (
        <HeroSuperText
          data-testid="hero-super-text"
          defaultTextColor={defaultTextColor}
          sanityTextColor={heroTextColor}
        >
          {heroSuperText}
        </HeroSuperText>
      )}
      {html && (
        <SanityHeroHeading
          data-testid="hero-heading"
          dangerouslySetInnerHTML={{ __html: html }}
          defaultTextColor={defaultTextColor}
          sanityTextColor={heroTextColor}
        />
      )}
      {heroSubText && (
        <SanityDescription
          data-testid="hero-sub-text"
          defaultTextColor={defaultTextColor}
          sanityTextColor={heroTextColor}
        >
          {heroSubText}
        </SanityDescription>
      )}
    </>
  );
};
